import { ltRequest, proto } from '../../main'

// customer 客户管理
const customerApi = {}

/**
 * 获取客户列表
 * @param {PBSearchCustomerListReq} query
 */
customerApi.getCustomerList = query => {
  const pbReq = proto.create('lottery.PBQueryCustomerListReq', query)
  return ltRequest('lottery.customerSearch', pbReq, 'lottery.PBCustomerRecordList')
}

/**
 * 根据客户ID 获取客户详情
 * @param {Number} customerId
 */
customerApi.getCustomerDetailById = customerId => {
  const pbReq = proto.create('framework.PBIntValue', {
    value: Number(customerId)
  })
  return ltRequest('lottery.customerDetail', pbReq, 'lottery.PBCustomerDetail')
}

/**
 * 根据用户ID 获取客户详情
 * @param {Number} userId
 */
customerApi.getCustomerDetailByUserId = userId => {
  const pbReq = proto.create('framework.PBIntValue', {
    value: Number(userId)
  })
  return ltRequest('lottery.customerDetailByUserId', pbReq, 'lottery.PBCustomerDetail')
}

customerApi.getCustomerById = customerId => {
  const pbReq = proto.create('framework.PBIntValue', {
    value: Number(customerId)
  })
  return ltRequest('lottery.customerGetById', pbReq, 'lottery.PBCustomer')
}

/**
 * 更新客户信息
 * @param {lottery.PBCustomer} customer
 */
customerApi.updateCustomer = customer => {
  const pbReq = proto.create('lottery.PBCustomer', customer)
  return ltRequest('lottery.customerUpdateInfo', pbReq)
}

/**
 * 获取用户已购接口
 * @param (int) customerId
 */
customerApi.getCustomerHistoryBoughtList = customerId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(customerId) })
  return ltRequest('lottery.customerHistoryBoughtInterfaceList', pbReq, 'lottery.PBUserInterfaceList')
}

/**
 * 获取用户已试用接口
 * @param (int) customerId
 */
customerApi.getCustomerHistoryTryList = customerId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(customerId) })
  return ltRequest('lottery.customerHistoryTryInterfaceList', pbReq, 'lottery.PBUserInterfaceList')
}

/**
 * 更新回访记录
 */
customerApi.updateReturnVisitRecord = param => {
  const pbReq = proto.create('fw.PBReturnVisitRecord', param)
  return ltRequest('lottery.customerReturnVisitRecordUpdate', pbReq)
}

/**
 * 添加回访记录
 */
customerApi.addVisitRecord = param => {
  const pbReq = proto.create('fw.PBReturnVisitRecord', param)
  return ltRequest('lottery.customerReturnVisitRecordAdd', pbReq)
}

customerApi.getReturnVisitRecordById = id => {
  const pbReq = proto.create('framework.PBLongValue', { value: Number(id) })
  return ltRequest('lottery.customerReturnVisitRecordGetById', pbReq, 'PBReturnVisitRecord')
}

customerApi.getCustomerContactList = userId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(userId) })
  return ltRequest('lottery.customerContactList', pbReq, 'fw.PBContactList')
}

// 根据ID获取联系人信息
customerApi.getCustomerContactById = contactId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(contactId) })
  return ltRequest('lottery.customerContactGetById', pbReq, 'fw.PBContact')
}

// 添加联系人
customerApi.addContact = contact => {
  const pbReq = proto.create('fw.PBContact', contact)
  return ltRequest('lottery.customerContactAdd', pbReq)
}

// 编辑联系人
customerApi.modifyContact = contact => {
  const pbReq = proto.create('fw.PBContact', contact)
  return ltRequest('lottery.customerContactModify', pbReq)
}

// delete contact
customerApi.deleteContact = contact => {
  const pbReq = proto.create('fw.PBContact', contact)
  return ltRequest('lottery.customerContactDelete', pbReq)
}

// 设未主对接人
customerApi.setPrimaryContact = param => {
  const pbReq = proto.create('fw.PBContact', param)
  return ltRequest('lottery.customerContactSetPrimary', pbReq, 'fw.PBContact')
}

customerApi.deleteVisitRecord = recordId => {
  const pbReq = proto.create('framework.PBLongValue', { value: Number(recordId) })
  return ltRequest('lottery.customerReturnVisitRecordDelete', pbReq)
}

// 编辑用户收货地址
customerApi.updateDeliveryAddress = address => {
  const pbReq = proto.create('fw.PBDeliveryAddress', address)
  return ltRequest('lottery.customerDeliveryAddressUpdateByAdmin', pbReq)
}

customerApi.addUserRemark = remark => {
  console.log(remark)
}

// 设置指定id的历史备注为置顶
customerApi.updateUserLogTopState = params => {
  const pbReq = proto.create('fw.PBUserLog', params)
  return ltRequest('lottery.userLogUpdateTop', pbReq)
}

// 获取对应分类下的置顶备注
customerApi.getTopUserLog = query => {
  const pbReq = proto.create('fw.PBGetUserLogListReq', query)
  return ltRequest('lottery.userLogGetTop', pbReq, 'fw.PBUserLogList')
}

// 分页获取对应分类的备注
customerApi.getUserLogByCategory = params => {
  const pbReq = proto.create('fw.PBGetUserLogListReq', params)
  return ltRequest('lottery.userLogGetByCategory', pbReq, 'fw.PBUserLogList')
}

export default customerApi



// WEBPACK FOOTER //
// ./src/api/lottery/customer.js